import React, { Component } from "react";

class Spinner extends Component {
  render() {
    return <div className="spinner"></div>;
  }
}

export default Spinner;
